import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ThirdPartyLogo } from '@silvertours/front-entities';
import { InteractiveText } from '@silvertours/front-shared';

const PrimaryWrapper = styled.div<{ isMinimal?: boolean }>`
  display: ${({ isMinimal }) => (isMinimal ? 'block' : 'none')};

  ${({ theme }) => theme.mq('sm')} {
    display: block;
  }
`;

const PrimaryTitle = styled.h1`
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: bold;
  font-size: 1.375rem;
  line-height: 1.25;
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral.grey160};

  ${({ theme }) => theme.mq('sm')} {
    text-align: left;
  }

  ${({ theme }) => theme.mq('lg')} {
    font-size: 1.75rem;
    line-height: 1.4285;
  }
`;

const SupplierContentGroup = styled.div<{ isLogoBarMode: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;

  /* In legacy mode, it occupies the right grid cell or full width on mobile */
  grid-column: ${({ isLogoBarMode }) => (isLogoBarMode ? 'span 2' : 'auto')};

  ${({ theme, isLogoBarMode }) => isLogoBarMode && theme.mq('lg')} {
    grid-column: auto;
    width: auto;
    flex: 1;
  }
`;

const SupplierList = styled.ul<{ isStandAlone: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  gap: 1rem;
  padding: 0;
  margin: 0;
  min-height: 4rem;

  ${({ theme }) => theme.mq('sm')} {
    min-height: auto;
  }

  ${({ theme }) => theme.mq('lg')} {
    padding: ${({ isStandAlone }) => (isStandAlone ? '0' : '0.5rem')} 1rem
      ${({ isStandAlone }) => (isStandAlone ? '0' : '0.5rem')} 1rem;
    justify-content: space-between;
    gap: ${({ isStandAlone }) => (isStandAlone ? '0' : '1.5rem')};
  }
`;

const SupplierListItem = styled.li`
  display: inline-flex;
  align-items: center;
`;

const SupplierWrapper = styled.div<{
  includeSearch: boolean;
  isMinimal?: boolean;
  isLogoBarMode?: boolean;
}>`
  display: grid;
  gap: 1rem;
  padding: ${({ isMinimal }) => (isMinimal ? '2rem 0 2rem' : '3rem 0 2rem')};

  /* Standard Grid (Legacy) */
  ${({ theme, includeSearch, isLogoBarMode }) =>
    includeSearch &&
    !isLogoBarMode &&
    css`
      ${theme.mq('lg')} {
        grid-template-columns: repeat(2, 0.5fr);
        align-items: end;
      }
      ${theme.mq('xl')} {
        grid-template-columns: 0.4fr 0.6fr;
      }
    `}

  /* Logo Bar Mode (Flex) */
  ${({ theme, isLogoBarMode }) =>
    isLogoBarMode &&
    css`
      ${theme.mq('lg')} {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 2rem;
        padding-top: 2rem;
      }
    `}
`;

const StyledThirdPartyLogo = styled(ThirdPartyLogo)`
  height: 1.5rem;
`;

const StyledInteractiveText = styled(InteractiveText)`
  font-size: ${({ theme }) => theme.fontSize.sm.size};
  line-height: ${({ theme }) => theme.fontSize.sm.lineHeight};
  text-align: left;
`;

export {
  PrimaryTitle,
  PrimaryWrapper,
  SupplierList,
  SupplierListItem,
  SupplierWrapper,
  StyledInteractiveText,
  StyledThirdPartyLogo,
  SupplierContentGroup,
};
